import { CommonModule } from '@angular/common';
import { Component, ElementRef, EventEmitter, Input, Output, QueryList, ViewChildren } from '@angular/core';
import { SideItem } from '../../Model/model';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-side-menu',
  imports: [CommonModule, MatIconModule],
  templateUrl: './side-menu.component.html',
  styleUrl: './side-menu.component.scss'
})
export class SideMenuComponent {

  @Input({ required: true }) items: SideItem[] = [];
  @Input() selectedId: string | null = null;
  @Output() itemSelected = new EventEmitter<SideItem>();

  selectedMenu: string = '';

  @ViewChildren('menuItemRef') menuItemRefs!: QueryList<ElementRef<HTMLElement>>;

  focusIndex = 0;


  goTo(param: string) {
    // console.log(param);
  }

  ngOnChange() {
    const idx = this.items.findIndex(i => i.contentId === this.selectedId)
    this.focusIndex = Math.max(0, idx)
    // this.focusItem();
  }

  select(item: SideItem, index: number) {
    // console.log(item, "itemmmmm")
    if (!item || (item as any).disabled) {
      // console.log('Blocked select of disabled item at side-menu component', item);
      return;
    }
    this.focusIndex = index
    this.itemSelected.emit(item);
  }

  


}
